export const BACKSPACE_KEY = 8;
export const DELETE_KEY    = 46;
export const TAB_KEY       = 9;
export const UP_KEY        = 38;
export const LEFT_KEY      = 37;
export const RIGHT_KEY     = 39;
export const DOWN_KEY      = 40;
export const ZERO_KEY      = 48;
export const NINE_KEY      = 57;
export const ENTER_KEY     = 13;
export const ESC_KEY       = 27;
export const P_KEY         = 80;
export const Q_KEY         = 81;
export const A_KEY         = 65;
export const Z_KEY         = 90;
export const SPACE_KEY     = 32;



// WEBPACK FOOTER //
// ./shared_critical/constants/keys.js